import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import Page from 'components/pages/Page';
import ValidationEvent from 'components/ui/form/ValidationEvent';
import ValidatedTextField from 'components/ui/form/ValidatedTextField';
import React, { useState } from 'react';
import User from 'uscc-services/lib/model/User';
import FormGroup from '@material-ui/core/FormGroup';
import CountrySelect from 'components/ui/form/CountrySelect';
import USStateSelect from 'components/ui/form/USStateSelect';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root:             { flexGrow: 1 },
    bottom:           { marginTop: '2em' },
    button:           { padding: '10px 20px' },
    buttonIcon:       { marginRight: '0.33em' },
    centeredPage:     { margin: '0 auto', width: '75vw', maxWidth: '1024px' },
    column:           { textAlign: 'left', color: theme.palette.text.secondary },
    textField:        { marginLeft: theme.spacing(1), marginRight: theme.spacing(1), width: '90%' },
    dense:            { marginTop: theme.spacing(2) },
    form:             { padding: '.5vw 2vw', border: '1px solid #6D9E11', borderRadius: '4px' },
    img:              { width: '100%', maxWidth: '300px' },
    extendedIcon:     { marginRight: theme.spacing(1) },
    right:            { float: 'right' },
    tiny:             { fontSize: '10pt' },
    validField:       {},
    invalidField:     { backgroundColor: '#FFcccc' }
  }),
);

export interface BusinessProfileForm {
  name: string,
  description: string,
  addressLine1?: string,
  addressLine2?: string,
  city?: string,
  state?: string,
  zipCode?: string,
  country?: string,
  phone?: string,
  email?: string,
  website?: string

}

export class BusinessProfileFormImpl implements BusinessProfileForm {
  name: string = '';
  description: string = '';
  addressLine1?: string = '';
  addressLine2?: string = '';
  city?: string = '';
  state?: string = '';
  zipCode?: string = '';
  country?: string = '';
  phone?: string = '';
  email?: string = '';
  website?: string = '';
}

export default function BusinessProfilePage(props: any) {
  const classes = useStyles(props.theme);
  let user: User = props.location.state.user;
  let profileForm = new BusinessProfileFormImpl();

  const [form, setForm] = useState<BusinessProfileForm>(profileForm);
  const [validations, setValidations] = useState<any>({
    businessName: true,
    description: true
  });

  let onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value: any = event.target.value;
    setForm({
      ...form,
      [event.target.name]: value
    });
  }
  
  let afterValidate = (event: ValidationEvent<HTMLInputElement>) => {
    setValidations({
      ...validations,
      [event.target.name]: event.isValid
    });
  }

  return (
    <Page>
      <Typography variant="h2">Let's create your Org Profile...</Typography>
      <FormGroup row>
        <Grid container>  
          <Grid item xs={6}>
            <ValidatedTextField
              required
              fullWidth
              name = "name"
              label = "Name of your Organization"
              value = { form.name } 
              onChange = { onChange }
              afterValidate = { afterValidate }
            />
            
            <ValidatedTextField
              required
              fullWidth
              name = "description"
              label = "General Description"
              value = { form.description } 
              onChange = { onChange }
              afterValidate = { afterValidate }
            />

            <ValidatedTextField
              fullWidth
              name = "website"
              label = "Website"
              value = { form.website } 
              onChange = { onChange }
              afterValidate = { afterValidate }
            />

            <ValidatedTextField
              fullWidth            
              name = "phone"
              label = "Phone"
              value = { form.phone } 
              onChange = { onChange }
              afterValidate = { afterValidate }
            />

            <ValidatedTextField
              email
              fullWidth
              name = "email"
              label = "Email"
              value = { form.email } 
              onChange = { onChange }
              afterValidate = { afterValidate }
            />
          </Grid>
          <Grid item xs={6}>
            <Typography>Where is it located?</Typography>

            <ValidatedTextField
              date
              fullWidth
              name = "addressLine1"
              label = "Address:"
              value = { form.addressLine1 } 
              onChange = { onChange }
              afterValidate = { afterValidate }
            />   

            <ValidatedTextField
              date
              fullWidth
              name = "addressLine2"
              label = ""
              value = { form.addressLine2 } 
              onChange = { onChange }
              afterValidate = { afterValidate }
            />               

            <ValidatedTextField
              date
              fullWidth
              name = "city"
              label = "City:"
              value = { form.city } 
              onChange = { onChange }
              afterValidate = { afterValidate }
            />   

            <CountrySelect
              name = "country"
              label = "Country"
              value = { form.country } 
              onChange = { onChange }
              afterValidate = { afterValidate }
            /> 

            <USStateSelect
              name = "state"
              label = "State"
              value = { form.state } 
              onChange = { onChange }
            />             

            <ValidatedTextField
              date
              fullWidth
              name = "zipCode"
              label = "ZipCode:"
              value = { form.zipCode } 
              onChange = { onChange }
              afterValidate = { afterValidate }
            />   
                        
          </Grid>
          <Grid item xs={12} className = { classes.bottom }>
            <Button 
              variant="contained"
              color="primary"
              aria-label = "Back" 
              className = { classes.button }
              onClick = { (event) => {
                //@TODO: add business info to user
                props.history.push({
                  pathname: 'profile',
                  state: {
                    user: user
                  }
                });
              } }
            >
              <Icon className = { clsx(classes.buttonIcon,  'fa fa-angle-left') } />
              Back
            </Button>
            
            <Button 
              variant="contained"
              color="primary"
              aria-label = "Continue" 
              className = { classNames(classes.button, classes.right) }
              endIcon = {
                <Icon className = { clsx(classes.buttonIcon,  'fa fa-angle-right') } />
              }
              onClick = { (event) => {
                props.history.push({
                  pathname: 'member-home',
                  state: {
                    user: user
                  }
                });

              } }
            >
              Continue
            </Button>
          </Grid>        
        </Grid>
      </FormGroup>
    </Page>
  );
}



